//detect Internet Explorer
//if (/MSIE (\d+\.\d+);/.test(navigator.userAgent)) {
//  window.location.href = '/#';
//}
//TODO: maak een pagina waarop staat dat IE niet ondersteud wordt en stuur de user daarheen.

import {NestedSelector} from "./controllers/nested-selector.ts";
import {ImageCropper} from "./controllers/image-cropper.ts";
import {rangeSlider} from "./components/range-slider.ts";
import {SiteSearch} from "./components/site-search.ts";
import {ConfirmModal} from "./components/confirm-modal.ts";
import {__} from "./libraries/translations.ts";
import lightGallery from 'lightgallery';

// Plugins
import lgThumbnail from 'lightgallery/plugins/thumbnail'
import lgZoom from 'lightgallery/plugins/zoom'
import {LeaveConfirmation} from "./libraries/leave-confirmation.ts";
import {setInputState} from "./forms";
import {DatePicker} from "./components/date-picker.ts";

require('bootstrap-daterangepicker');
require('bootstrap/js/src/toast');
require('./jquery.pagination.js');
require('./google-places-search.js');
require('./libraries/jquery-resizable.min');
require('slick-carousel/slick/slick.min.js');
require("cookie-notice/src/cookie.notice");
require("trumbowyg");
require("trumbowyg/plugins/history/trumbowyg.history");
require("trumbowyg/plugins/table/trumbowyg.table");
require("trumbowyg/plugins/resizimg/trumbowyg.resizimg");
require("trumbowyg/plugins/upload/trumbowyg.upload");
// require("trumbowyg/plugins/uploadfile/trumbowyg.uploadfile");
require("trumbowyg/dist/langs/nl");
const List = require("list.js");

const moment = require('moment');
const bootstrap = require('bootstrap');
const $ = require('jquery');
require('selectize');

const partialCollapseHeight = 200;

new cookieNoticeJS({
    messageLocales: {en: __('cookie-bar')},
    'buttonBgColor': 'inherit',
});

$.trumbowyg.svgPath = '/images/icons.svg';
// disable image pasting trumbowyg
(function ($) {
    'use strict';

    $.extend(true, $.trumbowyg, {
        plugins: {
            preventImagePaste: {
                init: function (trumbowyg) {
                    trumbowyg.pasteHandlers.push(function (pasteEvent) {
                        console.log('paste handler', pasteEvent);
                        try {
                            var items = (pasteEvent.originalEvent || pasteEvent).clipboardData.items,
                                mustPreventDefault = false,
                                reader;

                            for (var i = items.length - 1; i >= 0; i -= 1) {
                                if (items[i].type.match(/^image\//)) {
                                    mustPreventDefault = true;
                                }
                            }

                            if (mustPreventDefault) {
                                pasteEvent.stopPropagation();
                                pasteEvent.preventDefault();
                            }
                        } catch (c) {
                        }
                    });
                }
            }
        }
    });
})(jQuery);


// register serviceWorker
if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/service-worker.js');
}

$(document).ready(_ => {
    console.log('Welcome to ' + __('platform') + '.');
    {
        /**
         * WYSIWYG editor
         */
        $('textarea.wysiwyg').each((index, item) => {
            const el = $(item);
            el.trumbowyg({
                btns: el.data('buttons') ?? [['viewHTML'], ['bold', 'italic'], ['link'], ['removeformat'], ['unorderedList', 'orderedList'], ['table', 'horizontalRule'], ['upload', 'uploadfile'], ['historyUndo', 'historyRedo']],
                autogrow: true,
                lang: 'nl',
                defaultLinkTarget: '_blank',
                plugins: {
                    upload: {
                        serverPath: '/nl/user/file',
                        fileFieldName: 'file',
                        data: [{name: '_token', value: $('meta[name=csrf-token]').attr('content')}],
                        urlPropertyName: 'file'
                    },
                    uploadfile: {
                        serverPath: '/nl/user/file',
                        fileFieldName: 'file',
                        data: [{name: '_token', value: $('meta[name=csrf-token]').attr('content')}],
                        urlPropertyName: 'file'
                    }
                }
            });
        });
    }

    {
        /**
         * Prevent the page from reloading if form is dirty.
         * Add meta-tag with name prevent-reload to enable this.
         */
        if ($('meta[name=prevent-reload]').length > 0) {
            new LeaveConfirmation();
        }
    }

    {
        /**
         * Tooltips
         */
        const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));

        tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new bootstrap.Tooltip(tooltipTriggerEl)
        });
    }

    {
        /**
         * Toasts
         */
        [].slice.call(document.querySelectorAll('.toast')).map(function (toastEl) {
            return new bootstrap.Toast(toastEl)
        })
    }

    {
        /**
         * Nested selections
         */
        $('.nested-selection').each((i, el) => {
            new NestedSelector($(el).find('select').toArray(), window[$(el).data('name')]);
        });
    }

    {
        /**
         * Datepicker
         */
        const today = moment().format('DD-MM-YYYY');
        $('input.picker-date').each((index, element) => {

            // todo minimum date
            const minDate = $(element).hasClass('minimum-today') ? today : undefined;

            const dp = (new DatePicker(element))
                .onChange(val => {
                    console.log('change', val);
                });
            if (element.id === 'dateOfBirth') {
                const validatesStudent = element.classList.contains('dob-student');

                if (validatesStudent) {
                    dp.onChange(val => {
                        const years = moment().diff(val, 'years');

                        //TODO get min and max ages from system instead of hard code
                        if (years > 30) {
                            setInputState('#dateOfBirth', 'error', __('age-errors.old.0') + years + __('age-errors.old.1'));
                        } else if (years < 17) {
                            setInputState('#dateOfBirth', 'error', __('age-errors.young.0') + years + __('age-errors.young.1'));
                        } else {
                            setInputState('#dateOfBirth', 'success');
                        }
                    })
                }
            }
        });

        $('input.legacy-picker-date').on('apply.daterangepicker', function (ev, picker) {
            $(this).val(picker.startDate.format('DD-MM-YYYY'));
            $(this).blur(); //forces blur event to take place when user is done with field.
        });

        $('input.legacy-picker-date').on('cancel.daterangepicker', function (ev, picker) {
            $(this).val('');
        });

        $('input.legacy-picker-date').each((index, element) => {
            const minDate = $(element).hasClass('minimum-today') ? today : undefined;
            if (element.value === '') {
                $(element).daterangepicker({
                    singleDatePicker: true,
                    showDropdowns: ($(element).attr('data-dropdowns') == "true" ? true : false),
                    autoApply: true,
                    maxYear: parseInt(moment().format('YYYY'), 10),
                    locale: __('daterangepicker'),
                    autoUpdateInput: false,
                    cancelLabel: 'Clear',
                    startDate: today,
                    minDate
                });
            } else {
                $(element).daterangepicker({
                    singleDatePicker: true,
                    showDropdowns: ($(element).attr('data-dropdowns') == "true" ? true : false),
                    autoApply: true,
                    maxYear: parseInt(moment().format('YYYY'), 10),
                    locale: __('daterangepicker'),
                    startDate: element.value,
                    minDate
                });
            }
        });
    }

    {
        /**
         * Inappropriate content reporter
         */
        const modalElement = document.getElementById('inappropriateContentReportModal');
        if(modalElement) {
            const reportModal = new bootstrap.Modal(modalElement, {});
            $('.report-inappropriate').click((event) => {
                const element = $(event.currentTarget);
                $(modalElement).find('input[name=resourceType]').val(element.data('contentType'));
                $(modalElement).find('input[name=resourceId]').val(element.data('contentId'));
                reportModal.show();
            });
        }
    }

    {
        /**
         * Participation note editor
         */
        const participantNoteModal = document.getElementById('participantEditNoteModal');
        if(participantNoteModal) {
            const participantEditNoteUrl = $(participantNoteModal).find('form').attr('action');
            const bsModal = new bootstrap.Modal(participantNoteModal, {});
            $('.participant-edit-note').click((event) => {
                const element = $(event.currentTarget);

                const newUrl = participantEditNoteUrl
                    .replace('%user%', element.data('userId'))
                    .replace('-participation-', element.data('participationId'))
                    .replace('%activity%', element.data('activityId'));

                $(participantNoteModal).find('form').attr('action', newUrl);

                $(participantNoteModal).find('textarea[name=note]').val(element.data('note'));
                bsModal.show();
            });
        }
    }

    {

        //daterangepicker bug fix
        //prevent submitting form on enter press
        $(window).keydown(function (event) {
            if (event.keyCode == 13) {
                //pressed enter
                $(".daterangepicker").each(function () {
                    if ($(this).css("display") == "block") {
                        $(this).find(".applyBtn").trigger("click");
                        event.preventDefault();
                        return false;
                    }
                });

            }
        });

    }

    {
        /**
         * Confirmation modal
         */
        const modal = new ConfirmModal();
        $('button.require-confirmation').each((i, el) => {
            $(el).click(e => {
                e.preventDefault();
                modal.show($(el).data('question'), $(el).data('title'), () => {
                    var input = $("<input>").attr("type", "hidden").attr("name", $(el).attr('name')).val($(el).val());
                    $(el).closest('form').append(input).submit();
                }, () => {

                });
            });
        })
    }

    {
        /**
         * Croppie
         */
        $('.croppie').each((index, element) => {
            const el = $(element);
            let counter = 0;
            let cropper;
            const options = {
                boundary: {width: el.data('width'), height: el.data('height')},
                viewport: {
                    width: el.data('viewport-width'),
                    height: el.data('viewport-height'),
                    type: el.data('viewport-type')
                },
                update: _ => {
                    if (counter === 0)
                        cropper.croppie.setZoom(0);
                    counter++;
                }
            };
            if (el.data('result-width') !== undefined) {
                options.resultSize = {
                    width: el.data('result-width'),
                    height: el.data('result-height')
                };
            }
             cropper = new ImageCropper(
                el.data('crop-container') !== undefined ? $(el.data('crop-container')) : el.find('.crop-container'),
                el.find('.croppie-input'),
                el.data('save-button') !== undefined ? $(el.data('save-button')) : el.find('.croppie-save'),
                el.find('img.result'),
                el.find('input.croppie-data'),
                el.find('.placeholder'),
                options
            );
        });
    }

    {
        /**
         * Ajax Actions
         */
        $('.ajax-action').click(e => {
            e.preventDefault();
            let myAction = "";
            const el = $(e.currentTarget);
            //if action depends on active class, get the right action
            if (el.is('[data-action-active][data-action-passive]')) {
                if (el.hasClass('active')) {
                    myAction = el.attr('data-action-active');
                } else {
                    myAction = el.attr('data-action-passive');
                }
            } else {
                //else just get the action
                myAction = el.data('action');
            }

            $.ajax({
                method: 'patch',
                url: el.data('url'),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify({
                    action: myAction,
                    _token: $('meta[name=csrf-token]').attr('content')
                }),
                success: (data) => {
                    const toggleState = el.closest('.toggle-state');
                    if (toggleState !== undefined) {
                        $(toggleState[0]).attr('data-state', data.state);
                    }
                    if (el.attr('data-toast-message')) {
                        if (el.attr('data-toast-style')) {
                            showToast(el.attr('data-toast-message'), el.attr('data-toast-style'));
                        } else {
                            showToast(el.attr('data-toast-message'));
                        }
                    }
                    if (el.attr('data-slideUp')) {
                        const myTarget = el.attr('data-slideUp');
                        setTimeout(function () {
                            $(myTarget).slideUp();
                        }, 400);
                    }

                }
            });
        });
    }

    {
        /**
         * List.js
         */
        $('.searchable-list').each((index, list) => {
            try {
                new List(list, {valueNames: $(list).data('searchableClasses').split(',')});
            } catch (_) {

            }
        });

        //hide custom 'no matches' message
        $('.searchable-list .list-search-no-matches').slideUp(0);
    }

    {
        /**
         * Selectize.js
         */
        $(".selectize-default").selectize({
            create: true,
            sortField: "text",
            createOnBlur: true,
            render: {
                option_create: function (data, escape) {
                    const text = __('add').replace('{item}', escape(data.input));
                    return '<div class="create">' + text + '</div>';
                }
            },
        });
    }

    {
        /**
         * Switch language
         */
        $('select.system-language').change((event) => {
            const lang = $(event.target).val();
            let url = window.location.pathname;
            let path = url.replace(/^\/\w{2}/, '/' + lang);
            if (path.indexOf('?') > -1) {
                path += "&store-lang=true";
            } else {
                path += "?store-lang=true";
            }
            window.location.href = path;
        })
    }

    {
        /**
         * Range slider
         */
        $('.distance-container .distance-input').each((_, element) => {
            new rangeSlider(element);
        });
    }

    {
        /**
         * Search box
         */
        $('.siteSearch').each((_, element) => new SiteSearch(element, $($(element).data('resultsTarget'))));
    }

    {
        /**
         * Copy text
         */
        $('.copy-text').each((_, el) => {
            const input = $(el).find('input');
            const button = $(el).find('.btn');

            $(button).click(_ => {
                /* Select the text field */
                input[0].select();
                input[0].setSelectionRange(0, 99999); /* For mobile devices */

                /* Copy the text inside the text field */
                document.execCommand("copy");

                /* Alert the copied text */
                //alert('Link gekopieerd!'); // koen deze kopieer dinges doen svp graag dank feedback

                $(button).find('.badge').removeClass('d-none').addClass("animate bounceIn");
                setTimeout(function () {
                    $(avatarWrapper).removeClass("animate bounceIn")
                }, 500);
                setTimeout(function () {
                    $(button).find('.badge').addClass('d-none')
                }, 5000);

            });
        });
    }

    {
        /**
         * code validator
         */
        $('.ambassador-validator').each((i, item) => {
            const self = $(item);
            const route = self.data('route');
            const input = self.find('input');
            self.find('button').click(event => {
                $.ajax({
                    method: 'get',
                    url: route + '?code=' + input.val(),
                    contentType: 'application/json; charset=utf-8',
                    dataType: 'json',
                    success: function success(data) {
                        if ('publicDescription' in data) {
                            self.find('.code-valid').html(data.publicDescription);
                            self.find('.code-invalid').hide();
                            self.find('.code-valid').show();
                        } else {
                            self.find('.code-invalid').show();
                            self.find('.code-valid').hide();
                        }
                    }
                });
            });
            if (input.val()) {
                self.find('button').trigger('click');
            }
        });
    }

    /**
     * Lightgallery
     */
    {
        $('.lightgallery').each((i, el) => {
            lightGallery(el, {
                plugins: [lgZoom, lgThumbnail],
                speed: 500,
                licenseKey: '4D5CFD1D-E2044A70-B4E822B0-95171D7C',
                selector: 'a'
            });
        })
    }

    // mos collapse partial init

    $('[data-mos-toggle="collapse-partial"]').each(function () {
        //set transition attribute
        const target = $(this).attr('data-mos-target');
        $(target).attr('has-transition', $(target).hasClass('transition'));
    });

    refreshMOScollapsePartial();

    $('[data-mos-toggle="collapse-partial"]').each(function () {
        //on click, toggle partial collapse
        $(this).click(function () {
            const target = $(this).attr('data-mos-target');
            const isCollapsed = !$(this).hasClass('collapsed');
            if (isCollapsed) {
                $(target).css('height', partialCollapseHeight).addClass('collapsed');
                $(this).addClass('collapsed');
                $(target).addClass('fade-bottom');
            } else {
                $(target).css('height', $(this).attr('data-targetHeight')).removeClass('collapsed');
                $(this).removeClass('collapsed');
                $(target).removeClass('fade-bottom');
            }
        });
    });

    const promModal = $('#promotion-modal');
    if ($(promModal).length > 0) {
        (new bootstrap.Modal(promModal, {})).show();
    }
});

$(window).on('resize', function () {
    refreshMOScollapsePartial();
});


//generic interaction classes

$('.preventDefault').on("click", function (event) {
    event.preventDefault();
    return false;
});
$(document).on('click', '.stopPropagation', function (event) {
    event.stopPropagation();
});
$(document).on('click', '.refresh-page', function (event) {
    setTimeout(_ => location.reload(), 100); // defer by 100ms
});
$("*[data-trigger-element]").on("click", function (e) {
    e.preventDefault();
    let myElement = $(this).attr("data-trigger-element");
    $(myElement).trigger("click");
});
$("*[data-focus-element]").on("click", function (e) {
    e.preventDefault();
    let myElement = $(this).attr("data-focus-element");
    let myDelay = ($(this).attr("data-focus-delay") ? $(this).attr("data-focus-delay") : 0);
    setTimeout(function () {
        $(myElement).focus();
    }, myDelay)
});

$(document).on('click', '.mos-outer-trigger', function (event) {
    const clickedElement = $(event.target);
    const clickedElementHref = clickedElement.attr('href');
    if (clickedElementHref) {
        // whoops! Don't interrupt this action
        return;
    }

    const myTarget = $(event.target).closest(".mos-outer-trigger").find('.mos-inner-target');
    const href = $(myTarget).attr('href');
    const target = $(myTarget).attr('target') ?? '_self';

    if (href !== undefined) {
        window.open(href, target).focus();
        event.preventDefault();
    }
});

// listjs Search custom code for 'no matches' message
$('.searchable-list input.search').on('keyup change', function () {
    const myInput = $(this);
    const myList = $(this).parents('.searchable-list');

    $(myList).find('.list-search-query').text($(myInput).val());

    setTimeout(function () {
        //if search box has text and there are no elements in the list
        if ($(myInput).val() != '' && !$(myList).find('.list li').length) {
            $(myList).find('.list-search-no-matches').slideDown(0);
        } else {
            $(myList).find('.list-search-no-matches').slideUp(0);
        }
    }, 100);

})


// hide search on click outside of it,
// show search on click inside of it (if not empty)
$(document).on('click', function (e) {
    $('.siteSearchWrapper').each(function () {
        var myId = $(this).attr('id');
        const el = document.getElementById(myId);
        if (!!el && !el.contains(e.target)) {
            $(this).find('.siteSearchResults').addClass('d-none');
        } else {
            if ($(this).find('.siteSearch').val() != '') {
                $(this).find('.siteSearchResults').removeClass('d-none');
            }
        }
    })

});
// show search on type outside of it,
// hide search on type inside of it (if empty)
$('.siteSearch').on('input', function () {
    if ($(this).val() == '') {
        $(this).closest('.siteSearchWrapper').find('.siteSearchResults').addClass('d-none');
    } else {
        $(this).closest('.siteSearchWrapper').find('.siteSearchResults').removeClass('d-none');
    }
});

//croppie

$('.croppie-mos-cancel').click(function () {
    $(this).closest('.croppie').each(function () {
        $(this).find('.croppie-input').val("");
        $(this).find('.crop-container img').attr("src", "");
    })
});

//enable the submit button upon checking the copyright checkbox
$('.mos-croppie-copyright').change(function () {
    if ($(this).prop("checked") == true) {
        $(this).closest('.croppie').find('.mos-croppie-submit').prop("disabled", false);
    } else {
        $(this).closest('.croppie').find('.mos-croppie-submit').prop("disabled", true);
    }
})

//functions

function refreshMOScollapsePartial() {
    $('[data-mos-toggle="collapse-partial"]').each(function () {
        //get vars
        const target = $(this).attr('data-mos-target');
        let isCollapsed = $(this).hasClass('collapsed');

        //get expanded target height
        $(target).css('height', 'auto').removeClass('transition');
        const targetHeight = $(target).outerHeight();
        $(this).attr('data-targetHeight', targetHeight);

        //collapsed content is too small for collapsing to make sense?
        if (partialCollapseHeight + 40 > targetHeight) {
            isCollapsed = false; // don't collapse then
            $(this).addClass('d-none'); //hide expand button
        } else {
            $(this).removeClass('d-none'); //don't hide expand button
        }

        if (isCollapsed) {
            $(target).css('height', partialCollapseHeight).addClass('collapsed');
        } else {
            $(target).css('height', 'auto').removeClass('collapsed');
        }
        if ($(target).attr('has-transition')) {
            $(target).addClass('transition');
        }
    });
}

function showToast(message, style = 'info') {
    let myToast = $("<div class='toast-container manual-toast position-fixed top-0 start-50 translate-middle-x p-3' style='z-index:3000;''><div class='toast d-flex align-items-center show text-white bg-" + style + "' role='alert' aria-live='assertive' aria-atomic='true'><div class='toast-body'>" + message + "</div><button type='button' class='btn-close btn-close-white ms-auto me-2' data-bs-dismiss='toast' aria-label='" + __('common.close') + "'></button></div></div>");
    $('body').append(myToast);
}

//dismissing toasts doesnt work for this kind of toast (manual-toast), so heres a fix
$(document).on('click', '.manual-toast .btn-close', function (event) {
    const myTarget = $(event.target).closest('.manual-toast');
    $(myTarget).slideUp(200);
});

const carouselModal = document.getElementById("momentCarouselModal");
if (carouselModal) {
    const momentCarouselModal = new bootstrap.Modal(carouselModal, {});

    $(document).on('click', '.multiple-images-row img, .multiple-images-row .overlay-content', function (event) {
        $('#momentCarouselModal .carousel-item.active').removeClass('active');
        $('#momentCarouselModal img[data-key="' + $(this).attr('data-key') + '"]').closest('.carousel-item').addClass('active');
        momentCarouselModal.show();
    });
}

// Bugfix
// Bootstrap and trumbowyg don't play nice
// Tried and failed: https://stackoverflow.com/questions/41121577/ckeditor-link-input-not-working-in-modal/43104663#43104663
// Trying: https://github.com/Alex-D/Trumbowyg/issues/955
